module.exports = __webpack_public_path__ + "static/EWY_Bilaal_Social_Video-908c8566b3cba8d5303060641c39dfda.mp4";